import { AlertIcon } from '@american-autonomy/rantizo-ui';

import BaseNotification from 'components/BaseNotification';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WarningNotification: FunctionComponent<Props> = ({ onClose, testId = TEST_ID, text }) => (
    <BaseNotification
        className={styles.warningNotification}
        onClose={onClose}
        testId={testId}
        text={text}
    >
        <AlertIcon />
    </BaseNotification>
);

export default WarningNotification;
